import React from 'react';
import classNames from 'classnames';
import { UploadedPhoto } from '../prop-types';
import PropTypes from 'prop-types';

const urlRegexp = new RegExp(/[^/]+?(?=\?)|[^/]+$/, 'g');

export default function PhotoFilename({ photo: { filename }, className }) {
  if (!filename) return null;

  const [output] = filename.match(urlRegexp);

  return (
    <p
      className={classNames(
        'list-item__photos-filename text-truncate',
        className,
      )}>
      {output}
    </p>
  );
}

PhotoFilename.propTypes = {
  photo: UploadedPhoto.isRequired,
  className: PropTypes.string,
};
